module.exports = __webpack_public_path__ + "static/assets/0c8069027222ecfc5665dc2c65f5ac8d.png";